module.exports = __webpack_public_path__ + "img/page.ddfe3227.png";